import { useEffect } from 'react';
import { useFetcher } from 'react-router';
import { useAppDisplayModeContext } from '@archipro-design/aria';
import ArticlesCarouselDesktop from '../../../articles/component/articles-carousel/ArticlesCarousel.desktop';
import ArticlesCarouselMobile from '../../../articles/component/articles-carousel/ArticlesCarousel.mobile';
import type { ArticleGroupTypes } from '~/modules/articles/type';
import {
    type loader as articleLoader,
    HREF_ARTICLE_TILES,
} from '~/routes/remix-api.article.get-article-tiles';
import ArticleCarouselPlaceholder from '~/modules/articles/component/article-tile-skeleton/ArticleCarouselPlaceholder';

interface RelatedArticlesProps {
    articleCategoryLink: string;
}

const RelatedArticles: React.FC<RelatedArticlesProps> = ({
    articleCategoryLink,
}) => {
    const { mobile: isMobile } = useAppDisplayModeContext();

    const fetcher = useFetcher<typeof articleLoader>();
    const relatedArticles = fetcher.data;

    useEffect(() => {
        if (fetcher.state === 'idle' && fetcher.data == null) {
            fetcher.load(
                `${HREF_ARTICLE_TILES}?categoryLink=${articleCategoryLink}&limit=6&offset=3&randomSort=true`,
            );
        }
    }, [fetcher, articleCategoryLink]);

    const args = {
        title: 'RELATED STORIES',
        articleType: 'RelatedArticles' as ArticleGroupTypes,
    };

    return !relatedArticles ? (
        <ArticleCarouselPlaceholder title={args.title} />
    ) : (
        <>
            {isMobile ? (
                <ArticlesCarouselMobile
                    {...args}
                    articleTiles={relatedArticles}
                />
            ) : (
                <ArticlesCarouselDesktop
                    {...args}
                    articleTiles={relatedArticles}
                />
            )}
        </>
    );
};

export default RelatedArticles;
